"use client";

import type { LegacyRef, RefObject } from "react";
import { Search, X } from "lucide-react";
import { AeraButton } from "@aera/ui";
import { cn } from "../utils/cn";

export type DataTableSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  inputRef?: RefObject<HTMLInputElement | null>;
  /** Wide table chrome: transparent until hover. Compact: bordered field. */
  variant?: "wide" | "compact";
};

/** Search field used by รายรับ / รายจ่าย FilterBar — reuse on งานเงิน. */
export function DataTableSearchField({
  value,
  onChange,
  placeholder,
  inputRef,
  variant = "compact",
}: DataTableSearchFieldProps) {
  const isWide = variant === "wide";

  return (
    <div className="relative min-w-0 group">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-aera-charcoal transition-colors group-focus-within:text-aera-gray" />
      <input
        ref={inputRef as LegacyRef<HTMLInputElement> | undefined}
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={cn(
          "w-full min-w-0 truncate rounded-lg py-1.5 pl-9 pr-9 text-sm text-aera-charcoal outline-none transition-all placeholder:text-aera-gray cursor-text",
          value
            ? "bg-aera-lightgray/60"
            : isWide
              ? "bg-transparent hover:bg-aera-lightgray/60"
              : "border border-aera-lightgray bg-aera-white",
        )}
      />
      {value ? (
        <AeraButton
          variant="transparent"
          size="xs"
          onClick={() => onChange("")}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1!"
          icon={<X className="w-3.5 h-3.5" />}
        />
      ) : null}
    </div>
  );
}
